import { render, staticRenderFns } from "./ResubmitDetail.vue?vue&type=template&id=006025ba&"
import script from "./ResubmitDetail.vue?vue&type=script&lang=js&"
export * from "./ResubmitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports